<template>
  <md-dialog :md-active.sync="isVisible" v-if="submission && isVisible">
    <md-dialog-title>Submission Details ({{ submission.product.lender_name }}: {{
        submission.product.product_name
      }})
    </md-dialog-title>
    <md-dialog-content>
      <group-card icon="emoji_transportation">
        <group-card-row title="Asset Costs">
          <template v-slot:content>
            <div class="property-list">
              <property-view name="Purchase Cost">
                {{ security.purchase_cost | currency }}
              </property-view>
              <property-view name="Deposit">
                {{ security.deposit_value | currency }}
              </property-view>
              <property-view name="Accessories Cost">
                {{ security.accessories_cost | currency }}
              </property-view>
              <property-view name="Trade In">
                {{ security.trade_in_value | currency }}
              </property-view>
            </div>
          </template>
        </group-card-row>
      </group-card>
      <group-card icon="paid">
        <group-card-row title="Fees">
          <template v-slot:content>
            <div class="property-list">
              <property-view name="DOF">
                {{ submission.document_origination_fee | currency }}
              </property-view>
              <property-view name="Establishment Fee">
                {{ submission.establishment_fee | currency }}
              </property-view>
              <property-view name="PPSR Fee">
                {{ submission.ppsr_fee | currency }}
              </property-view>
              <property-view name="Risk Fee">
                {{ submission.risk_fee | currency }}
              </property-view>
            </div>
            <div class="property-list">
              <property-view name="Total Fees (calculated)">
                {{ total_fees | currency }}
              </property-view>
              <property-view name="Total Insurance Cost (calculated)">
                {{ total_insurance_fee | currency }}
              </property-view>
            </div>
          </template>
        </group-card-row>
      </group-card>
      <group-card icon="horizontal_split">
        <group-card-row title="Repayments">
          <template v-slot:content>
            <div class="property-list">
              <property-view name="NAF (calculated)">
                {{ naf | currency }}
              </property-view>
              <property-view name="Rate">
                {{ submission.rate | currency }}
              </property-view>
              <property-view name="Balloon Amount">
                {{ submission.balloon_amount | currency }}
              </property-view>
              <property-view name="Term">
                {{ submission.term }}
              </property-view>
              <property-view name="Payment Frequency">
                {{ submission.payment_frequency }}
              </property-view>
              <property-view name="Monthly Account Keeping Fee">
                {{ submission.monthly_account_fee | currency }}
              </property-view>
              <property-view name="Repayments">
                {{ repayment_message }}
              </property-view>
              <br>
            </div>
          </template>
        </group-card-row>
      </group-card>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button class="md-primary md-simple" @click="onCancel"
      >Close
      </md-button
      >
    </md-dialog-actions>
  </md-dialog>
</template>
<script>
import {mapGetters} from 'vuex';
import {Badge} from "@/components";
import {GroupCard} from "@/components";
import {GroupCardRow} from "@/components";
import {PropertyView} from "@/components";
import {NoteView} from "@/components";
import filters from "../utils/filters";
import utils from "../utils/utils";

export default {
  components: {
    Badge,
    GroupCard,
    GroupCardRow,
    PropertyView,
    NoteView
  },
  data() {
    return {}
  },
  props: {
    submission: {
      type: Object | null,
      required: true
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...filters,
    onCancel() {
      this.isVisible = false;
    },
  },
  computed: {
    ...mapGetters([
      'application',
      'application_status',
      'security'
    ]),
    isVisible: {
      get() {
        return this.active;
      },
      set(value) {
        this.$emit("onCancel", value);
      }
    },
    total_fees() {
      let document_origination_fee = this.float(
        this.submission.document_origination_fee
      );
      let establishment_fee = this.float(
        this.submission.establishment_fee
      );
      let ppsr_fee = this.float(this.submission.ppsr_fee);
      let risk_fee = this.float(this.submission.risk_fee);

      return Math.round((document_origination_fee + establishment_fee + ppsr_fee + risk_fee) * 100) / 100;
    },
    total_insurance() {
      return this.application.loan.insurances.reduce(
        (sum, insurance) => sum + (insurance.include_in_naf ? this.float(insurance.premium) : 0),
        0
      );
    },
    naf() {
      return this.submission.naf ?? 0;
    },
    repayment_message() {
      let periodic_payments = this.currency(this.repayment_amount);
      let frequency = this.submission.payment_frequency;
      let term = this.submission.term;
      let number_of_payments = Math.round(
        term / utils.frequencyConversionFactor("Monthly", frequency)
      );

      if (periodic_payments) {
        return `${number_of_payments} ${frequency} payments of ${periodic_payments}`;
      } else {
        return null;
      }
    },
    repayment_amount() {
      if (!this.application) {
        return null;
      }
      let amount = this.submission.naf;
      let annual_rate = this.submission.rate;
      let monthly_account_fee = this.submission.monthly_account_fee;
      let term = this.submission.term;
      let repayment_frequency = this.submission.payment_frequency;
      let balloon_amount = this.submission.balloon_amount;

      return utils.calculateRepayments(
        amount,
        annual_rate,
        term,
        "Monthly",
        repayment_frequency,
        monthly_account_fee,
        balloon_amount
      );
    },
  },
  filters: {
    ...filters,
  },
  mounted() {
  },
}
</script>
